import {
  SET_OWN_SERIES,
  SET_MANAGE_SERIES,
  UPDATE_MANAGE_SERIES,
  CLEAR_MANAGE_SERIES,
  SET_MANAGE_SECTION,
  SET_CONTACT_FORM,
  IManagementState,
  ManagementActionTypes,
} from './types'

export const initialState = {
  contactForm: false,
  series: [],
}

const reducer = (
  state: IManagementState = initialState,
  action: ManagementActionTypes
): IManagementState => {
  switch (action.type) {
    case SET_OWN_SERIES:
      return {
        ...state,
        series: action.payload,
      }
    case SET_MANAGE_SERIES:
      return {
        ...state,
        managing: action.payload,
      }
    case CLEAR_MANAGE_SERIES:
      return {
        ...state,
        managing: undefined,
        section: undefined,
        subSection: undefined
      }
    case UPDATE_MANAGE_SERIES:
      return {
        ...state,
        update: action.payload,
      }
    case SET_MANAGE_SECTION:
      return {
        ...state,
        sectionParam: action.payload.sectionParam,
        section: action.payload.section,
        subSection: action.payload.subSection,
      }
    case SET_CONTACT_FORM:
      return {
        ...state,
        contactForm: action.payload,
      }
    default:
      return state
  }
}

export default reducer
